module.exports = __webpack_public_path__ + "img/127.10.91baca83.png";